"use client";
import { motion } from "framer-motion";
import { useRef } from "react";

const ANIMATION_PRESETS = {
  fadeUp: {
    initial: { opacity: 0, y: 30 },
    whileInView: {
      opacity: 1,
      y: 0,
    },
  },
  fadeLeft: {
    initial: { opacity: 0, x: 80 },
    whileInView: {
      opacity: 1,
      x: 0,
    },
  },
  fadeRight: {
    initial: { opacity: 0, x: -80 },
    whileInView: {
      opacity: 1,
      x: 0,
    },
  },
};

const MotionContainer = ({
  children,
  className = "",
  preset = "fadeUp",
  delay = 0.2,
  duration = 0.5,
}) => {
  const ref = useRef(null);

  const animation = {
    ...ANIMATION_PRESETS[preset],
    whileInView: {
      ...ANIMATION_PRESETS[preset].whileInView,
      transition: {
        delay,
        duration,
      },
    },
  };

  return (
    <motion.div
      ref={ref}
      {...animation}
      viewport={{ once: true, amount: 0.1 }}
      className={className || undefined}
    >
      {children}
    </motion.div>
  );
};

export default MotionContainer;
